import Axios from "../../../../api/axios/Axios";

const creatorPath = (username) =>
  `/api/creators/${encodeURIComponent(username)}/albums`;

export const getCreatorAlbums = (username) => Axios.get(creatorPath(username));

export const getCreatorAlbum = (username, albumId) =>
  Axios.get(`${creatorPath(username)}/${encodeURIComponent(albumId)}`);

export const getCreatorAlbumByTag = (username, albumTag) =>
  Axios.get(
    `/api/creators/${encodeURIComponent(username)}/albums/tag/${encodeURIComponent(albumTag)}`,
  );

export const getCreatorAlbumEditData = (username, albumId) =>
  Axios.get(`${creatorPath(username)}/${encodeURIComponent(albumId)}/edit`);

export const getCreatorAvailableGroups = (username) =>
  Axios.get(`${creatorPath(username)}/groups`);

export const createCreatorAlbum = (username, data) =>
  Axios.post(creatorPath(username), data);

export const updateCreatorAlbum = (username, albumId, data) =>
  Axios.put(`${creatorPath(username)}/${encodeURIComponent(albumId)}`, data);

export const deleteCreatorAlbum = (username, albumId) =>
  Axios.delete(`${creatorPath(username)}/${encodeURIComponent(albumId)}`);

export const deleteCreatorAlbumImage = (username, albumId, imageId) =>
  Axios.delete(
    `${creatorPath(username)}/${encodeURIComponent(albumId)}/images/${encodeURIComponent(imageId)}`,
  );
